/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import Loading from '../../components/loading/loading.component';
import PropTypes from 'prop-types';
import * as consts from '../../const.js';
import { ControlLabel, Form, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import { Button } from 'tc-client-common';
import Notification from '../common/notification/notification.component';

class ParticipantEmailModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      reason: ''
    };
    this.handleParticipantEmailChange = this.handleParticipantEmailChange.bind(this);
    this.changeReasonHandler = this.changeReasonHandler.bind(this);
    this.updateParticipantEmail = this.updateParticipantEmail.bind(this);
  }

  handleParticipantEmailChange(event) {
    const value = event.target.value;
    this.setState(() => ({ email: value }));
  }

  changeReasonHandler(event) {
    const value = event.target.value;
    this.setState(() => ({ reason: value }));
  }

  updateParticipantEmail(e) {
    e.preventDefault();
    const { email, reason } = this.state;
    const { updateParticipantEmail, participantJourney } = this.props;
    const { userId: id, gid, language } = participantJourney || {};
    const payload = { id, email, language, ...(reason ? { reason } : {}) };
    updateParticipantEmail(gid, payload);
  }

  render() {
    const { isLoading, error } = this.props;
    let errorBody = '';
    if (error) {
      errorBody = (
        <Row>
          <Notification type="error" data={error} />
        </Row>
      );
    }

    return (
      <Form horizontal id="edit-participant-email-form" onSubmit={this.updateParticipantEmail}>
        <Grid id="edit-participant-email-grid" fluid>
          {errorBody}
          <Row>
            <FormGroup controlId="participant-email-input">
              <ControlLabel>{consts.NEW_PARTICIPANT_EMAIL_LABEL}</ControlLabel>
              <FormControl
                type="email"
                onChange={this.handleParticipantEmailChange}
                required
                value={this.state.email}
                disabled={isLoading}
              />
            </FormGroup>
            <FormGroup controlId="reason">
              <ControlLabel>
                {consts.NEW_PARTICIPANT_EMAIL_REASON}
                <span> *</span>
              </ControlLabel>
              <FormControl
                componentClass="textarea"
                value={this.state.reason}
                onChange={this.changeReasonHandler}
                required
                disabled={isLoading}
              />
            </FormGroup>
          </Row>
        </Grid>
        <div className="edit-modal-footer">
          <hr className="edit-modal-divider" />
          <Button
            id="edit-participant-email-cancel-button"
            theme="default large-button"
            type="reset"
            disabled={isLoading}
            handleClick={() => {
              this.props.hide();
            }}
            label={consts.CANCEL_BTN}
          />
          <Button
            id="edit-participant-email-save-button"
            theme="active large-button"
            type="submit"
            disabled={isLoading}
            label={consts.SAVE_BTN}
          >
            {isLoading ? <Loading /> : null}
          </Button>
        </div>
      </Form>
    );
  }
}

ParticipantEmailModal.propTypes = {
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  participantJourney: PropTypes.object.isRequired,
  hide: PropTypes.func
};

export default ParticipantEmailModal;
